var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { staticClass: "event", attrs: { column: "" } },
    [
      _c(
        "chat-user-header",
        {
          attrs: {
            "main-icon": "message",
            event: _vm.event,
            participants: _vm.participants
          }
        },
        [_vm._v("commented")]
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        {
          staticClass: "text-xs-left event-line ml-1 pl-4",
          attrs: { xs12: "", sm12: "", "align-center": "" }
        },
        [
          _c("span", { staticClass: "font-weight-light message" }, [
            _vm._v(_vm._s(_vm.event.message))
          ])
        ]
      ),
      _vm._v(" "),
      _vm.showTime
        ? _c(
            "v-flex",
            {
              staticClass:
                "text-sm-right text-sm-left event-line font-weight-light caption pr-2",
              attrs: { xs12: "", sm2: "", "align-self-center": "" }
            },
            [
              _c("span", [
                _vm._v(_vm._s(_vm._f("formatDate")(_vm.event.timestamp)))
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2562c934", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2562c934","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/timeline/UserCommentEvent.vue
// module id = null
// module chunks = 